import React from "react";

export default function ListFormat(props) {

  var numberList = '';

  if (props.numbers.length > 2) {
    for (var i = 0; i < props.numbers.length; i++) {
      numberList += props.numbers[i];

      if (i < props.numbers.length - 1) {
        // Gotta get that oxford comma
        numberList += ', ';
        if (i === props.numbers.length - 2) {
          numberList += 'and '
        }
      }
    }
  } else if (props.numbers.length === 2) {
    numberList = props.numbers.join(' and ');
  } else {
    numberList = props.numbers;
  }

  return (
    <span>{numberList}</span >
  );
}
